import { Component, OnInit } from '@angular/core';

import * as $ from 'jquery';
import { Config } from '../../../../../../config/config';
import { LiteStaticViewDataServiceService } from '../../../../../../service/lite/lite-static-view-data-service.service';
import { RestDataService } from '../../../../../../service/rest-data.service';
import { SharedDataService } from '../../../../../../service/shared-data.service';
import { StaticDataService } from '../../../../../../service/static-data.service';
import { StaticViewDataService } from '../../../../../../service/static-view-data-service.service';
import { LeftMenuComponent } from '../../../../../left-menu/left-menu.component';
@Component({
  selector: '.liteleftMenu',
  templateUrl: './lite-left-menu.component.html',
  styleUrls: ['./lite-left-menu.component.scss']
})
export class LiteLeftMenuComponent implements OnInit {

  constructor(
    public config: Config,
    private sharedService: SharedDataService,
    private restService:RestDataService
  ) {
    this.buttons = LiteStaticViewDataServiceService.Left_Menu_View.buttons;
    if(this.sharedService.isdomainConfig('feeds','showTranslationFeed')) {
      this.buttons.find((o,i) => {
        if (o.class === 'translatedFeeds') {
          this.buttons[i]['enable'] = true;
          return true; 
        }
      })
    }
    if(this.sharedService.isdomainConfig('feeds','showEnglishTranslationFeed')) {
      this.buttons.find((o,i) => {
        if (o.class === 'translatedFeeds') {
          this.buttons[i]['enable'] = true;
          return true; 
        }
      })
    }
  }

    name: string;
    nameArray: string[];
    inits: string;
    initsArray: string[];
    profileImageUrl = null;
    role: string;
    userDomains = [];
    selectedDomain: any;
    buttons;
    
  
  ngOnInit() {
    const token =  JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral));
    this.selectedDomain = sessionStorage.getItem(StaticDataService.domainLiteral);
    this.userDomains = JSON.parse(localStorage.getItem(StaticDataService.domains_all));
    this.profileImageUrl = token.user.pictureUrl;
    this.name = token.name;
    this.nameArray = this.name.split(' ');
    this.initsArray = this.name.split(' ');
    this.name = '';
    this.inits = '';
    this.role = token.user.domainPermissions[this.selectedDomain].role.replace('ROLE_', '').replace('_', ' ');
    for (const i in this.initsArray) {
      if (parseInt(i, 10) < 2) {
        if (/^[a-zA-Z0-9]*$/.test(this.nameArray[i]) === true) {
          this.name += this.nameArray[i] + ' ';
          this.inits += this.initsArray[i].charAt(0).toUpperCase();
        }
      }
    }
  }

  onDomainChange($event) {
    //tenant name required for GA
    let allTenantData=JSON.parse(localStorage.getItem(StaticDataService.allDomains));
    let index;
    let tenantName;
    this.selectedDomain = $event.target.value;
    index=allTenantData.findIndex((value)=>value.id== this.selectedDomain);
    tenantName=allTenantData[index].name
    sessionStorage.setItem(StaticDataService.domainLiteral, this.selectedDomain);
    sessionStorage.setItem(StaticDataService.tenantName, tenantName);

    window.location.reload();
  }

  changeDropdownView() {
   return $('.mainContainer').hasClass('storyEditor');
  }

  
}

